'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UITooltipContent = require('UIComponents/tooltip/UITooltipContent');

var _UITooltipContent2 = _interopRequireDefault(_UITooltipContent);

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLTIP_HOVER_DELAY = 1000;

var propTypes = {
  children: _react.PropTypes.node.isRequired,
  placement: _react.PropTypes.string,
  responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
  showTooltip: _react.PropTypes.bool
};

var defaultProps = {
  showTooltip: false
};

var AvatarTooltip = function (_Component) {
  _inherits(AvatarTooltip, _Component);

  function AvatarTooltip(props) {
    _classCallCheck(this, AvatarTooltip);

    var _this = _possibleConstructorReturn(this, (AvatarTooltip.__proto__ || Object.getPrototypeOf(AvatarTooltip)).call(this, props));

    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  _createClass(AvatarTooltip, [{
    key: 'renderTitle',
    value: function renderTitle() {
      var isBot = (0, _responderGetters.getIsBot)(this.props.responder);
      var fullName = (0, _responderGetters.getFullName)(this.props.responder);

      if (isBot) {
        return _react2.default.createElement(_FormattedMessage2.default, { message: 'ui-addon-conversations.chat.responders.bot' });
      }

      if (!fullName) {
        return _react2.default.createElement(_FormattedMessage2.default, { message: 'ui-addon-conversations.chat.responders.unknown' });
      }

      return fullName;
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      return _react2.default.createElement(
        _UITooltipContent2.default,
        null,
        this.renderTitle()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          showTooltip = _props.showTooltip,
          placement = _props.placement;


      return _react2.default.createElement(
        _UITooltip2.default,
        {
          delay: TOOLTIP_HOVER_DELAY,
          disabled: !showTooltip,
          Content: this.renderContent,
          placement: placement
        },
        children
      );
    }
  }]);

  return AvatarTooltip;
}(_react.Component);

AvatarTooltip.displayName = 'AvatarTooltip';
AvatarTooltip.propTypes = propTypes;
AvatarTooltip.defaultProps = defaultProps;

exports.default = AvatarTooltip;
module.exports = exports['default'];